export default __webpack_public_path__ + "static/Case-Study-AI-Lead-Distribution-9f51c7ff9e7b62eb6e3cf1b04904c96b.pdf";